import { logManager } from '../../logs'
import BasicError, { callCodes } from '../../errors'

// Libraries.
import { call } from 'redux-saga/effects'

const log = logManager.getLogger('CALLSTACK')

/**
 * Use the WebRTC stack to create a local Media object.
 * @method createLocal
 * @param  {Object} webRTC           The WebRTC stack.
 * @param  {Object} mediaConstraints The native gUM constraints.
 * @return {Object} Results object, with either `media` or `error` property.
 */
export function * createLocal (webRTC, mediaConstraints) {
  log.debug('Getting media with constraints: ', mediaConstraints)

  // Default return values.
  const result = { medias: [], error: false }

  try {
    if (mediaConstraints.screenShare) {
      const screenShareConstraints = {
        video: mediaConstraints.screenShare
      }

      const screenShareMedia = yield call([webRTC.media, 'createLocalScreen'], screenShareConstraints)
      result.medias.push({
        type: 'screen',
        media: screenShareMedia
      })
    }

    if (mediaConstraints.audio) {
      const audioConstraints = {
        audio: mediaConstraints.audio
      }
      const audioMedia = yield call([webRTC.media, 'createLocal'], audioConstraints)
      result.medias.push({
        type: 'audio',
        media: audioMedia
      })
    }

    if (mediaConstraints.video) {
      const videoConstraints = {
        video: mediaConstraints.video
      }
      const videoMedia = yield call([webRTC.media, 'createLocal'], videoConstraints)
      result.medias.push({
        type: 'video',
        media: videoMedia
      })
    }
  } catch (err) {
    let errMessage
    if (err.name === 'OverconstrainedError') {
      errMessage = `Failed to get media due to constraint: ${err.constraint}.`
    } else {
      errMessage = `Failed to get media => Name: ${err.name}; Error Message :${err.message}.`
    }

    log.info(errMessage)

    // Clean up successful media object when there is partial media failure.
    for (const eachMedia of result.medias) {
      yield call([eachMedia.media, 'stop'])
    }

    result.error = new BasicError({
      message: errMessage,
      code: callCodes.USER_MEDIA_ERROR
    })
  }

  return result
}
